export const CUSTOMER_EVENTS = {
  NA: 'NA',
  NOT_AVAIL: 'NotAvailable',
  REPAIRED: 'Repaired',
  FAILED_REPAIR: 'FailedRepair',
  CUST_REPAIRED: 'CustomerRepaired',
  ENG_VISIT: 'EngineerVisit',
  ENG_VISIT_NO_LEAK: 'EngineerVisitNoLeak',
  COMP_REPAIR: 'CompleteRepair',
  FAILED_CUST_REPAIR: 'FailedCustomerRepaired',
  COMP_CUST_REPAIR: 'CompleteCustomerRepaired',
  CANCEL_BOOKING: 'CancelBooking',
  NULL: 'null'
}
